import { useLocation, useNavigate } from 'react-router-dom';
import { useCallback } from 'react';
import { Paper, Tab, Tabs, Typography } from '@mui/material';
import { availableUpdateProductTabs } from '../../../variables/UpdateProduct';
import { DummyScrollButton } from '../../GeneralSettings/GeneralSettingsTabs';
import { sharedStyles } from '../../../utils/Style';

interface UpdateProductTabsProps {
  productID: number;
}

export const UpdateProductTabs = (props: UpdateProductTabsProps) => {
  const navigate = useNavigate();
  const location = useLocation();

  const paths = location.pathname.split('/');

  const selectedTabIndex = Math.max(
    availableUpdateProductTabs.findIndex((tab) => paths.includes(tab.path)),
    0,
  );

  const handleChange = useCallback(
    (_: any, i: number) =>
      navigate(
        `/products/catalog/${props.productID}/${availableUpdateProductTabs[i].path}${location.search}`,
      ),
    [],
  );

  return (
    <Paper>
      <Tabs
        variant='scrollable'
        value={selectedTabIndex}
        onChange={handleChange}
        ScrollButtonComponent={DummyScrollButton}
      >
        {availableUpdateProductTabs.map((tab) => (
          <Tab
            key={tab.kind}
            label={
              <Typography sx={sharedStyles.tabLabel}>{tab.name}</Typography>
            }
          />
        ))}
      </Tabs>
    </Paper>
  );
};
